<div class="card">
  <div class="grid">
    <div class="col-12 md:col-4">
      <div *ngIf="!this.isMachineLoading" class="h-24rem mt-6">
        <img class="flex max-w-full h-20rem m-auto" [src]="machine.model.image" alt="{{ 'attribute.machineImage' | transloco}}">
      </div>
      <div *ngIf="this.isMachineLoading" class="w-full h-24rem mx-2 my-2">
        <p-skeleton height="24rem"></p-skeleton>
      </div>
      <div *ngIf="!this.isMachineLoading && this.machineTechnicalInfo != null" class="col-12 ml-2 mt-2">
        <div class="ml-2 grid">
          <div class="col-12">
            <b>{{ 'attribute.machineType' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.type == 0">{{ 'command.value.none' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.type == 1 && machine?.model.machineType !== MachineType.ESSENTIAL">{{ 'command.value.versatile' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.type == 1 && machine?.model.machineType === MachineType.ESSENTIAL">{{ 'command.value.essential' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.type == 2">{{ 'command.value.speed' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.type == 4">{{ 'command.value.soulFalcon' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.type == 8">{{ 'command.value.soulAperton' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.type == 16">{{ 'command.value.speedAt' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.type == 32">{{ 'command.value.zitrux' | transloco}}</span>
            <span *ngIf="!machineTechnicalInfo.type">N/A&nbsp;</span>
          </div>
          <div *ngIf="machine?.model.machineType === MachineType.SPEED" class="col-12">
            <b>{{ 'attribute.machineModel' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.model == 0">{{ 'command.value.basic' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.model == 1">{{ 'command.value.selfService' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.model == 2">{{ 'command.value.tankPodium' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.model == 3">{{ 'command.value.cooler' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.model == 4">{{ 'command.value.selfServiceMD' | transloco}}</span>
            <span *ngIf="!machineTechnicalInfo.type">N/A&nbsp;</span>
          </div>
          <div *ngIf="machine?.model.machineType !== MachineType.ZITRUX" class="col-12">
            <b>{{ 'attribute.workingMode' | transloco}}: </b>
            <span *ngIf="(machine?.model.machineType === MachineType.SPEED && machineTechnicalInfo.workingMode == 0) || (machine?.model.machineType === MachineType.ESSENTIAL && machineTechnicalInfo.workingMode == 3)">
              {{ 'command.value.automatic' | transloco}}
            </span>
            <span *ngIf="(machine?.model.machineType === MachineType.SPEED && machineTechnicalInfo.workingMode == 1) || (machine?.model.machineType === MachineType.VERSATILE && machineTechnicalInfo.workingMode == 2)">
              {{ 'command.value.professional' | transloco}}
            </span>
            <span *ngIf="machine?.model.machineType === MachineType.SOUL && machineTechnicalInfo.workingMode == 0">
              {{ 'command.value.normal' | transloco}}
            </span>
            <span *ngIf="machine?.model.machineType === MachineType.SOUL && machineTechnicalInfo.workingMode == 1">
              {{ 'command.value.automaticExtended' | transloco}}
            </span>
            <span *ngIf="machineTechnicalInfo.workingMode == 1 && (machine?.model.machineType === MachineType.VERSATILE || machine?.model.machineType === MachineType.ESSENTIAL)">
              {{ 'command.value.selfService' | transloco}}
            </span>
            <span *ngIf="machineTechnicalInfo.workingMode == 5 && (machine?.model.machineType === MachineType.VERSATILE || machine?.model.machineType === MachineType.ESSENTIAL)">
              {{ 'command.value.cashless' | transloco}}
            </span>

            <span *ngIf="machineTechnicalInfo.workingMode == 4 && machine?.model.machineType === MachineType.ESSENTIAL">
              {{ 'command.value.professionalEssential' | transloco}}
            </span>
            <span *ngIf="!machineTechnicalInfo.workingMode">N/A&nbsp;</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.bootVersion' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.bootVersion">{{ machineTechnicalInfo.bootVersion }}</span>
            <span *ngIf="!machineTechnicalInfo.bootVersion">N/A&nbsp;</span>
          </div>
          <div class="col-12" *ngIf="machine?.model.machineType === MachineType.ZITRUX">
            <b>{{ 'attribute.bootVersionElevator' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.bootVersionElevator">{{ machineTechnicalInfo.bootVersionElevator }}</span>
            <span *ngIf="!machineTechnicalInfo.bootVersionElevator">N/A&nbsp;</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.firmwareVersionIot' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.firmwareVersionIot">{{ machineTechnicalInfo.firmwareVersionIot }}</span>
            <span *ngIf="!machineTechnicalInfo.firmwareVersionIot">N/A&nbsp;</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.firmwareVersionMachine' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.firmwareVersion">{{ machineTechnicalInfo.firmwareVersion }}</span>
            <span *ngIf="!machineTechnicalInfo.firmwareVersion">N/A&nbsp;</span>
          </div>
          <div class="col-12" *ngIf="machine?.model.machineType === MachineType.ZITRUX">
            <b>{{ 'attribute.firmwareVersionMachineElevator' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.firmwareVersionElevator">{{ machineTechnicalInfo.firmwareVersionElevator }}</span>
            <span *ngIf="!machineTechnicalInfo.firmwareVersionElevator">N/A&nbsp;</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.protocolVersion' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.protocolVersion">{{ machineTechnicalInfo.protocolVersion }}</span>
            <span *ngIf="!machineTechnicalInfo.protocolVersion">N/A&nbsp;</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.withFlash' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.withFlash == 0">{{ 'command.value.no' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.withFlash == 1">{{ 'command.value.yes' | transloco}}</span>
            <span *ngIf="!machineTechnicalInfo.withFlash">N/A&nbsp;</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.withBootBoot' | transloco}}: </b>
            <span *ngIf="machineTechnicalInfo.withBootBoot == 0">{{ 'command.value.no' | transloco}}</span>
            <span *ngIf="machineTechnicalInfo.withBootBoot == 1">{{ 'command.value.yes' | transloco}}</span>
            <span *ngIf="!machineTechnicalInfo.withBootBoot">N/A&nbsp;</span>
          </div>
        </div>
      </div>
      <div *ngIf="this.isMachineLoading" class="col-12 ml-2">
        <div class="grid mt-4">
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div *ngIf="machine?.model.machineType === MachineType.SPEED" class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div *ngIf="machine?.model.machineType === MachineType.SPEED" class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div *ngIf="machine?.model.machineType !== MachineType.ZITRUX" class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div *ngIf="machine?.model.machineType !== MachineType.ZITRUX" class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div *ngIf="machine?.model.machineType === MachineType.ZITRUX" class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div *ngIf="machine?.model.machineType === MachineType.ZITRUX" class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div *ngIf="machine?.model.machineType === MachineType.ZITRUX" class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div *ngIf="machine?.model.machineType === MachineType.ZITRUX" class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!this.isMachineLoading && this.machineCommandSchema != null" class="col-12 md:col-8 md:p-3">
      <ng-container *ngIf="this.machineCommandSchema.name === 'zmxconnect-0262-v1'">

        <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE || machine?.model.machineType === MachineType.ZITRUX">
          <div class="pt-4 command-title">{{'command.title.sweeperConfiguration' | transloco}}</div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6"
                 *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE || machine?.model.machineType === MachineType.ZITRUX">
              <iot-zmxconnect-0262-v1-set-sweeper-enabled
                [params]="this.machineCommandSchema.commands['setSweeperEnabled']"
                [configuration]="this.configuration.commands['setSweeperEnabled']"
                [command]="'setSweeperEnabled'"
                (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-sweeper-enabled>
            </div>
            <div class="col-12 md:col-12 lg:col-6"
                 *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE">
              <iot-zmxconnect-0262-v1-set-sweeper-mode [params]="this.machineCommandSchema.commands['setSweeperMode']"
                                                       [configuration]="this.configuration.commands['setSweeperMode']"
                                                       [command]="'setSweeperMode'"
                                                       (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-sweeper-mode>
            </div>
            <div class="col-12 md:col-12 lg:col-6"
                 *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE">
              <iot-zmxconnect-0262-v1-set-sweeper-speed [params]="this.machineCommandSchema.commands['setSweeperSpeed']"
                                                        [configuration]="this.configuration.commands['setSweeperSpeed']"
                                                        [command]="'setSweeperSpeed'"
                                                        (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-sweeper-speed>
            </div>
          </div>
        </div>

        <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE || machine?.model.machineType === MachineType.ZITRUX">
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="pt-4 command-title">{{'command.title.wasteConfiguration' | transloco}}</div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-waste-enabled [params]="this.machineCommandSchema.commands['setWasteEnabled']"
                                                        [configuration]="this.configuration.commands['setWasteEnabled']"
                                                        [command]="'setWasteEnabled'"
                                                        (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-waste-enabled>
            </div>
            <div class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-waste-limit [params]="this.machineCommandSchema.commands['setWasteLimit']"
                                                      [configuration]="this.configuration.commands['setWasteLimit']"
                                                      [command]="'setWasteLimit'"
                                                      (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-waste-limit>
            </div>
          </div>
          <hr *ngIf="machine?.model.machineType !== MachineType.ZITRUX" style="border-color: #eceeec; width: 65%;" class="mx-auto">
        </div>

        <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE || machine?.model.machineType === MachineType.SOUL">
          <div class="pt-4 command-title">{{'command.title.machineConfiguration' | transloco}}</div>
          <div class="grid">
            <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE" class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-language
                [params]="this.machineCommandSchema.commands['setLanguage']"
                [configuration]="this.configuration.commands['setLanguage']"
                [command]="'setLanguage'" (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-language>
            </div>
            <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE" class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-fruits-pro [params]="this.machineCommandSchema.commands['setFruitsPro']"
                                                     [configuration]="this.configuration.commands['setFruitsPro']"
                                                     [command]="'setFruitsPro'" (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-fruits-pro>
            </div>
            <div *ngIf="machine?.model.machineType === MachineType.SPEED" class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-lock-pro [params]="this.machineCommandSchema.commands['setLockPro']"
                                                   [configuration]="this.configuration.commands['setLockPro']"
                                                   [command]="'setLockPro'" (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-lock-pro>
            </div>
            <div *ngIf="machine?.model.machineType === MachineType.SPEED" class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-sel-up-down-disc
                [params]="this.machineCommandSchema.commands['setSelUpDownDisc']"
                [configuration]="this.configuration.commands['setSelUpDownDisc']"
                [command]="'setSelUpDownDisc'"
                (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-sel-up-down-disc>
            </div>
            <div *ngIf="machine?.model.machineType === MachineType.SPEED" class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-up-value [params]="this.machineCommandSchema.commands['setUpValue']"
                                                   [configuration]="this.configuration.commands['setUpValue']"
                                                   [command]="'setUpValue'" (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-up-value>
            </div>
            <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE" class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-down-value-disc
                [params]="this.machineCommandSchema.commands['setDownValueDisc']"
                [configuration]="this.configuration.commands['setDownValueDisc']"
                [command]="'setDownValueDisc'"
                (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-down-value-disc>
            </div>
            <div *ngIf="machine?.model.machineType === MachineType.SOUL || machine?.model.machineType === MachineType.VERSATILE" class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-cashless-mode-fruit-number
                [params]="this.machineCommandSchema.commands['setCashlessModeFruitNumber']"
                [configuration]="this.configuration.commands['setCashlessModeFruitNumber']"
                [command]="'setCashlessModeFruitNumber'" (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-cashless-mode-fruit-number>
            </div>
          </div>
        </div>

        <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE">
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="pt-4 command-title">{{'command.title.credentialsConfiguration' | transloco}}</div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-pin-ct [params]="this.machineCommandSchema.commands['setPinCt']"
                                                 [configuration]="this.configuration.commands['setPinCt']"
                                                 [command]="'setPinCt'"
                                                 (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-pin-ct>
            </div>
            <div class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-pin-master [params]="this.machineCommandSchema.commands['setPinMaster']"
                                                     [configuration]="this.configuration.commands['setPinMaster']"
                                                     [command]="'setPinMaster'"
                                                     (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-pin-master>
            </div>
            <div class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-pin-user [params]="this.machineCommandSchema.commands['setPinUser']"
                                                   [configuration]="this.configuration.commands['setPinUser']"
                                                   [command]="'setPinUser'"
                                                   (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-pin-user>
            </div>
            <div class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-pin-sat [params]="this.machineCommandSchema.commands['setPinSat']"
                                                  [configuration]="this.configuration.commands['setPinSat']"
                                                  [command]="'setPinSat'"
                                                  (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-pin-sat>
            </div>
          </div>
        </div>

        <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE || machine?.model.machineType === MachineType.SOUL">
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="pt-4 command-title">{{'command.title.iotConfiguration' | transloco}}</div>
          <div class="grid">
            <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE" class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-iot-timeout [params]="this.machineCommandSchema.commands['setIotTimeout']"
                                                      [configuration]="this.configuration.commands['setIotTimeout']"
                                                      [command]="'setIotTimeout'"
                                                      (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-iot-timeout>
            </div>
            <div *ngIf="machine?.model.machineType === MachineType.SPEED || machine?.model.machineType === MachineType.VERSATILE" class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-iot-sel-control
                [params]="this.machineCommandSchema.commands['setIotSelControl']"
                [configuration]="this.configuration.commands['setIotSelControl']"
                [command]="'setIotSelControl'"
                (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-iot-sel-control>
            </div>
            <div class="col-12 md:col-12 lg:col-6">
              <iot-zmxconnect-0262-v1-set-comm-tech
                [params]="this.machineCommandSchema.commands['setCommTech']"
                [configuration]="this.configuration.commands['setCommTech']"
                [command]="'setCommTech'"
                (onExecute)="this.executeCommand($event)">
              </iot-zmxconnect-0262-v1-set-comm-tech>
            </div>
          </div>
        </div>

        <hr *ngIf="machine?.model.machineType !== MachineType.ESSENTIAL && machine?.model.machineType !== MachineType.NONE" style="border-color: #eceeec; width: 65%;" class="mx-auto">
        <div class="pt-4 command-title mb-3">{{'command.title.iotCommands' | transloco}}</div>
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-6 xl:col-3">
            <iot-zmxconnect-0262-v1-reboot [params]="this.machineCommandSchema.commands['reboot']"
                                           [configuration]="this.configuration.commands['reboot']"
                                           [command]="'reboot'"
                                           (onExecute)="this.executeCommand($event)">
            </iot-zmxconnect-0262-v1-reboot>
          </div>
        </div>

        <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
        <div class="pt-4 command-title mb-3">{{'command.title.machineCommands' | transloco}}</div>
        <div class="grid">
          <div *ngIf="machine?.model.machineType !== MachineType.ZITRUX && machine?.model.machineType !== MachineType.NONE" class="col-12 md:col-12 lg:col-6 xl:col-3">
            <iot-zmxconnect-0262-v1-machine-enable [params]="this.machineCommandSchema.commands['machineEnable']"
                                                   [configuration]="this.configuration.commands['machineEnable']"
                                                   [command]="'machineEnable'"
                                                   (onExecute)="this.executeCommand($event)">
            </iot-zmxconnect-0262-v1-machine-enable>
          </div>
          <div *ngIf="machine?.model.machineType !== MachineType.ZITRUX && machine?.model.machineType !== MachineType.NONE" class="col-12 md:col-12 lg:col-6 xl:col-3">
            <iot-zmxconnect-0262-v1-machine-disable [params]="this.machineCommandSchema.commands['machineDisable']"
                                                    [configuration]="this.configuration.commands['machineDisable']"
                                                    [command]="'machineDisable'"
                                                    (onExecute)="this.executeCommand($event)">
            </iot-zmxconnect-0262-v1-machine-disable>
          </div>
          <div *ngIf="machine?.model.machineType === MachineType.SOUL" class="col-12 md:col-12 lg:col-6 xl:col-3">
            <iot-zmxconnect-0262-v1-machine-cpu-reset [params]="this.machineCommandSchema.commands['machineCpuReset']"
                                                      [configuration]="this.configuration.commands['machineCpuReset']"
                                                      [command]="'machineCpuReset'"
                                                      (onExecute)="this.executeCommand($event)">
            </iot-zmxconnect-0262-v1-machine-cpu-reset>
          </div>
          <div class="col-12 md:col-12 lg:col-6 xl:col-3">
            <iot-zmxconnect-0262-v1-machine-reset-partial-fruit-counter
              [params]="this.machineCommandSchema.commands['machineResetPartialFruitCounter']"
              [configuration]="this.configuration.commands['machineResetPartialFruitCounter']"
              [command]="'machineResetPartialFruitCounter'"
              (onExecute)="this.executeCommand($event)">
            </iot-zmxconnect-0262-v1-machine-reset-partial-fruit-counter>
          </div>
          <div *ngIf="machine?.model.machineType === MachineType.SOUL || machine?.model.machineType === MachineType.VERSATILE" class="col-12 md:col-12 lg:col-6 xl:col-3">
            <iot-zmxconnect-0262-v1-machine-fruits-cashless-reset
              [params]="this.machineCommandSchema.commands['machineFruitsCashlessReset']"
              [configuration]="this.configuration.commands['machineFruitsCashlessReset']"
              [command]="'machineFruitsCashlessReset'"
              (onExecute)="this.executeCommand($event)">
            </iot-zmxconnect-0262-v1-machine-fruits-cashless-reset>
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="!this.isMachineLoading && this.machineCommandSchema == null" class="col-12 md:col-8 md:p-3 mt-4">
      <div class="pt-4 command-title mb-3">{{'command.title.noCommandSchema' | transloco}}</div>
    </div>
    <div *ngIf="this.isMachineLoading" class="col-12 md:col-8 md:p-3">
      <div class="mb-3">
        <div class="mb-2">
          <p-skeleton height="1.5rem" width="15rem"></p-skeleton>
        </div>
        <div class="flex justify-content-between">
          <p-skeleton height="2.5rem" width="20rem"></p-skeleton>
          <p-skeleton height="2.5rem" width="8rem"></p-skeleton>
        </div>
      </div>
      <div class="mb-3">
        <div class="mb-2">
          <p-skeleton height="1.5rem" width="15rem"></p-skeleton>
        </div>
        <div class="flex justify-content-between">
          <p-skeleton height="2.5rem" width="20rem"></p-skeleton>
          <p-skeleton height="2.5rem" width="8rem"></p-skeleton>
        </div>
      </div>
      <div class="mb-3">
        <div class="mb-2">
          <p-skeleton height="1.5rem" width="15rem"></p-skeleton>
        </div>
        <div class="flex justify-content-between">
          <p-skeleton height="2.5rem" width="20rem"></p-skeleton>
          <p-skeleton height="2.5rem" width="8rem"></p-skeleton>
        </div>
      </div>
      <div class="mb-3">
        <div class="mb-2">
          <p-skeleton height="1.5rem" width="15rem"></p-skeleton>
        </div>
        <div class="flex justify-content-between">
          <p-skeleton height="2.5rem" width="20rem"></p-skeleton>
          <p-skeleton height="2.5rem" width="8rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>
